import React from 'react';
import styled from "styled-components";
import PriceService from '../../services/PriceService';
import toThousand from '../../services/ToThousandService';
import { useDolarPrice } from '../../hooks/useDolarPrice';

export default function StirrupsSquaresPrices(props){

    const pricesStirrupsSquares = PriceService.pricesStirrupsSquares;

    const [dolar, currentDate] = useDolarPrice();

    console.log(pricesStirrupsSquares);
    
    
    return (
        <StylePrices>

        <div style={{ backgroundColor: 'var(--colorFondoMain)'}}>
            <div className="scrollPrice container">
                
                <h2 style={{textAlign: 'center'}}>Tabla de de Estribos Cuadrados y Rectangulares</h2>                    
                    {pricesStirrupsSquares && (
                        <>
                        <div className="contenedorTablaPrecio">
                            <table className="tablaPrecio">
                                <thead>
                                <tr className="subTituloPrice">
                                    <td rowSpan="2">Imagen</td>
                                    <td rowSpan="2">Código</td>
                                    <td rowSpan="2">Diámetro Barra</td>
                                    <td colSpan="2">Dimensión Columna (cm)</td>
                                    <td colSpan="2">Dimensión Real Estribo (cm)</td>
                                    <td rowSpan="2">Cobertura (cm)</td>
                                    <td rowSpan="2">Cantidad en Empaque</td>
                                    {/* <td rowSpan="2" className="columnaDolar">Precio U$S + IVA</td>
                                    <td rowSpan="2" className="columnaPesos">Precio $ + IVA</td> */}
                                </tr>
                                <tr className="subTituloPrice">
                                    <td>Lado A</td>
                                    <td>Lado B</td>
                                    <td>Lado A</td>
                                    <td>Lado B</td>
                                </tr>
                                </thead>
                                <tbody>
                                {pricesStirrupsSquares.map((item, index) => {
                                    const rowClassName = (index % 2 === 0) ? "filaPricePar" : "filaPriceImpar";
                                    return (
                                        <tr key={item.id} className={rowClassName}>
                                        {index === 0 && (
                                            <>
                                            <td rowSpan={pricesStirrupsSquares.length} style={{ backgroundColor: '#fff' }}>
                                                <img src="/assets/img/stirrups/cuadrado.jpg" alt="Estribo Cuadrado" style={{ width: '250px', padding: '0.5rem' }} />
                                            </td>
                                            
                                            </>
                                        )}
                                        <td>{item.cod}</td>
                                        <td>{item.mod}</td>
                                        <td>{item.largo}</td>
                                        <td>{item.ancho}</td>
                                        <td>{item.largoReal}</td>
                                        <td>{item.anchoReal}</td>
                                        <td>{item.cobertura}</td>
                                        <td>{item.empaque}</td>
                                        {/* <td className="columnaDolar">{toThousand(item.price)}</td>
                                        <td className="columnaPesos">{toThousand(item.price * dolar)}</td> */}
                                    </tr>
                                    );
                                })}
                                </tbody>
                            </table>
                        </div>
                        </>
                    )}
            </div>
        </div>
        </StylePrices>
    )
}

const StylePrices = styled.div`
    .iconScroll{
        display: flex;
        justify-content: center;
        color: var(--colorPrimario);
        @media (min-width: 992px){
            display:none;
        }
    }
    .scrollPrice{
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding-bottom: 2rem;
        @media(min-width: 992px){
            display: flex;
            align-items: center;
        }
    }
    .contenedorTablaPrecio::-webkit-scrollbar{
        height: 15px;
        border-radius: 10px;
        background-color: var(--colorSecundario);
    }
    .contenedorTablaPrecio::-webkit-scrollbar-thumb{
        background-color: var(--colorPrimario);
        border-radius: 10px;
        width: 5px;
    }
    .contenedorTablaPrecio{
        overflow-x: scroll;
        flex-direction: column;
        width: 100%;
        @media (min-width: 992px){
            width: 100%;
            display: flex;
            flex-direction: column ;
            justify-content: space-between;
            margin-top: 2rem;
            ::-webkit-scrollbar {display:none;} //Oculta la barra de scroll sin perder la funcion
        }
    }

    .tablaPrecio{
        margin-top: 0.5rem;
        margin-bottom: 1.5rem;
        width: 100%;
        border-collapse:collapse;
        margin-right: 10px;
        text-align: center;
        @media (min-width: 768px){
            justify-self: flex-end; /* Alinear tabla a la derecha */
        }
    }
    .tituloPrice{
        background-color: var(--colorPrimario);
        margin: 20px;
    }
    .tituloPrice td{
        color: #fff;
        font-family: var(--fuenteSecundaria);
        font-weight: 700;
        font-size: 20px;
        padding: 20px;
    }
    .subTituloPrice{
        background-color: var(--colorGris);
        font-family: var(--fuenteSecundaria);
        color: #fff;
        padding: 5px;
    }
    .subTituloPrice td{
        padding: 10px;
        width: 10%;
        font-weight: 600;
    }
    .filaPricePar {
        background-color: var(--colorFilaTabla);
        font-weight: 500;
    }
    .filaPricePar td{
        padding: 5px;
        font-weight: 500;
    }
    .filaPriceImpar{
        background-color: #fff;
        font-weight: 500;
    }
    .filaPriceImpar td{
        padding: 5px;
        font-weight: 500;
    }
    .columnaDolar{
        background-color: var(--colorTerciario);
        color: #fff;
    }
    .columnaPesos{
        background-color: var(--colorPrimario);
        color: #fff;
    }
    td {
        font-size: 13px;
        @media (min-width: 768px){
            font-size: 15px;
        }
    }
`